import FadeIn from "@/compoments/fadeIn";
import React, { useMemo } from "react";
import styles from './index.module.scss'
import SideMenu from "./sideMenu";
import classNames from "classnames";
import Footer from "../casino/compoment/footer";
import MineChildRoute from "./mineChildRoute";
import { useLayout } from "@/layout";
import useDeviceType, { isDeviceType } from "@/commonHooks/useDeviceType";
import TopMenu from "./compoment/topMenu";

const Mine = () => {

    const {deviceType } = useLayout()
    const hideSide = isDeviceType(deviceType, "<=middlePc")


    return (
        <FadeIn>
            <div className={styles.maxContentWrapper}>
                <div className={classNames(styles.warpper)}>
                    {hideSide ? <TopMenu /> : <SideMenu />}
                    <div className={styles.rightWarpper}>
                        <MineChildRoute />
                    </div>
                </div>
            </div>
            <div className="w-full mt-[100px]">
                <Footer />
            </div>
        </FadeIn>
    )
}


export default Mine